<template>
  <div>
    <ul class="collection" v-if="programs.length > 0" >
          <li class="collection-item avatar" v-for="[key, program] in programs" :key="key">
              <i class="icon-text circle center" :class="program.intensity | intensityColor">{{program.code}}</i>
              <span class="title">{{program.name}}</span>
              <p>{{program.type}}</p>
              
              <div class="secondary-content">
                <router-link :to="{ name: 'ProgramEdit', params: { programKey: key, user: user  }}">
                  <i class="material-icons">edit</i>
                </router-link>
                <a @click="copyProgram(key, program)" href="#"><i  class="material-icons blue-text">content_copy</i></a>
                <a @click="deleteProgram(key)" href="#"><i  class="material-icons red-text">delete</i></a>
              </div>
          </li>
    </ul>
    <div class="row">
      <div class="col s12 center-align"> 
        <a class="waves-effect waves-light btn blue" @click="addProgram()">Add</a>
      </div>
    </div>
  
  </div>
</template>

<script>
import api from '@/api'
import M from 'materialize-css'
import {cloneData} from '@/helpers/object'
export default {
  name: 'programList',
  props: {
    user: Object
  },
  components: {},
  data: function () {
    return {
      programs: [],
      seq_copy: 1

    }
  },
  mounted () {
    this.programs = api.getProgramList()
    this.$events.$on('programs-changed', () => {
      this.programs = api.getProgramList()
    })
  },
  methods: {
    refresh: function () {
      this.programs = api.getProgramList()
    },
    addProgram: function () {
      const n = Object.keys(this.programs).length
      const newKey = 'new-' + n
      const nProgram = {
        code: '??',
        name: 'New program',
        type: undefined,
        intensity: undefined
      }
      this.programs.push([newKey, nProgram])
      api.updateProgramList(this.programs)
      M.toast({html: 'Program added! Please change the key'})
    },
    copyProgram: function (toCopyKey, toCopyDesc) {
      // Copy program description
      const newKey = toCopyKey + '-copy'
      const existing = this.programs.findIndex(([key, val]) => {
        return key === newKey
      })
      if (existing !== -1) {
        M.toast({html: 'Duplicate already exist! Please change the key before'})
        return
      }
      const nProgram = cloneData(toCopyDesc)
      nProgram.name = 'Copy of ' + nProgram.name
      this.programs.push([newKey, nProgram])
      api.updateProgramList(this.programs)
      // Copy sessions
      const program = cloneData(api.getProgram(toCopyKey))
      program.description = nProgram
      program.name = newKey
      api.updateProgram(newKey, program)
      M.toast({html: 'Program copied! Please change the key'})
    },
    deleteProgram: function (toRemoveKey) {
      if (!confirm('Delete the program?')) return
      const existing = this.programs.findIndex(([key, val]) => {
        return key === toRemoveKey
      })
      if (existing !== -1) {
        this.programs.splice(existing, 1)
        api.updateProgramList(this.programs)
      }
      M.toast({html: 'Program removed!'})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/coach/ProgramList.vue